import $ from 'jquery'
import Toggler from 'luminate/src/modules/toggler'

export default Toggler.extend({
	directive: 'notification',

	defaults: {
		duration: 0 // How many days to hide the notification banner for after it's closed
	},

	events: {

		beforeInit: function(e)
		{
			let closed = false

			if(e.settings.duration > 0)
			{
				if(localStorage.notified)
				{
					const delta = Date.now() - localStorage.notified
					const msDuration = e.settings.duration * 24 * 60 * 60 * 1000

					if(delta >= msDuration)
					{
						delete localStorage.notified
					}
					else
					{
						closed = true
					}
				}
			}
			else
			{
				if(localStorage.notified)
				{
					closed = true
				}
			}

			e.settings.is = closed ? 'closed' : 'open'
		},

		init: function()
		{
			this.on('change', function()
			{
				if(this.isClosed() && !localStorage.notified)
				{
					localStorage.notified = Date.now()
				}
			})
		},

		action: function(e)
		{
			if(e.event.type == 'submit')
			{
				e.stopPropagation = true
			}
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/modules/notification.js